import PropTypes from 'prop-types';
import React from 'react';

import './dropdown.scss';

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOptions: false,
      value: props.value,
    };
  }

  //TODO: this seems like it shouldn't be necessary; rethink it
  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({value: nextProps.value});
    }
  }

  handleVisibilityClick = () => {
    this.setState({showOptions: !this.state.showOptions});
  }

  handleOptionClick = (value) => {
    this.setState({
      showOptions: false,
      value: value,
    });
    this.props.handleChange(this.props.name, value);
  }

  lookUpLabelByValue = (value) => {
    const matches = this.props.options.filter(function (option) {
      return option.value === value;
    });
    const match = matches.length > 0 ? matches[0] : this.props.options[0];
    if (match && match.label) {
      return match.label;
    } else if (value === 'innerLoop') {//TODO: this belongs elsewhere
      return 'inner loop';
    } else {
      return '';
    }
  }

  render() {
    const options = this.props.options.map((option, index) => {
      return (
        <li onClick={this.handleOptionClick.bind(this, option.value)} key={index}>
          {option.label}
        </li>
      );
    });
    const stateClass = this.state.showOptions ? 'state-up' : 'state-down';
    return (
      <div className={'dropdown-container ' + stateClass} tabIndex="0">
        <div
          className={'select-dropdown contained state-down'}
          onClick={this.handleVisibilityClick.bind(this)}
          >
          {this.lookUpLabelByValue(this.state.value)}
          <img className="arrow-down" src="/img/arrow-down-black.png" alt="arrow-down"/>
        </div>
        <ul className="option-list">
          {options}
        </ul>
      </div>
    );
  }
}

DropDown.propTypes = {
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};

export default DropDown;



// WEBPACK FOOTER //
// ./src/components/search/controls/dropdown/index.js